export enum TypesSelect {
  DEFAULT = 'default',
  TRANSPARENT = 'transparent',
  OUTLINE = 'outline',
}
